import { CanvasObjectSize } from '@y42/json-schema';

export const getImageDimensions = (imageUrl: string): Promise<CanvasObjectSize> =>
  new Promise((resolve) => {
    const img = new Image();
    img.src = imageUrl;
    img.onload = function () {
      resolve({ width: img.width, height: img.height });
    };
  });
